import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局路由守卫
import "./router/permission"

Vue.config.productionTip = false

//框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import * as echarts from 'echarts' //引入echarts
Vue.prototype.$echarts = echarts //引入组件

// 炫酷的粒子动效
import VueParticles from 'vue-particles';
Vue.use(VueParticles);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
